/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_d6144cdc"]'><cube-button public-id="xxxxxx" open-type="lifestyle" tip="需在支付宝小程序环境预览" @followLifestyle='(e)=>__invoke(e, [["onFollowLifestyle"]])'>关注生活号</cube-button></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_d6144cdc"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_d6144cdc"}
  /** script content **/
  require("./btn-follow-lifestyle.mpx.js?isComponent&outputPath=components%2Fbtn-follow-lifestyled6144cdc%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./btn-follow-lifestyle.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fbtn-follow-lifestyled6144cdc%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_d6144cdc"],
    ctorType: "component",
    outputPath: "components/btn-follow-lifestyled6144cdc/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>